const DEFAULT_STATE_KEY = 'catalog-collect';

function getCatalogCollectElement(el = null) {
	if (el) {
		let container = el.closest('.catalog-collections');
		if (container) {
			let inContainer = container.querySelector('#catalog-collect');
			if (inContainer) {
				return inContainer;
			}
		}
	}

	return document.getElementById('catalog-collect');
}

function getStateKey(catalogCollect) {
	if (!catalogCollect) {
		return DEFAULT_STATE_KEY;
	}

	return catalogCollect.dataset.stateKey || DEFAULT_STATE_KEY;
}

function saveSliderState(el) {
	let catalogCollect = getCatalogCollectElement(el);
	if (!catalogCollect) {
		return;
	}

	let stateKey = getStateKey(catalogCollect);
	let index = catalogCollect.swiper ? catalogCollect.swiper.activeIndex : null;

	if (index === null || typeof index === 'undefined' || isNaN(index)) {
		return;
	}

	sessionStorage.setItem(stateKey, String(index));
}

function restoreSliderState() {
	let catalogCollect = getCatalogCollectElement();
	if (!catalogCollect) {
		return;
	}

	let savedIndexRaw = sessionStorage.getItem(getStateKey(catalogCollect));
	if (savedIndexRaw === null) {
		return;
	}

	let index = parseInt(savedIndexRaw, 10);
	if (isNaN(index) || index < 0) {
		return;
	}

	if (catalogCollect.swiper) {
		catalogCollect.swiper.slideTo(index, 0, false);
	}
}

listener('click', '.catalog-collect--list-item', (el, e) => {
	let container = el.closest('.catalog-collections');

	let all = container.querySelector('.catalog-collect--all');
	if (all) {
		all.classList.remove('active');
	}

	container.querySelectorAll('.catalog-collect--list-item').forEach((item) => {
		item.classList.remove('active');
	})

	el.classList.add('active');
	saveSliderState(el);
});

listener('click', '.catalog-collect--all', (el, e) => {
	el.classList.add('active');

	let container = el.closest('.catalog-collections');
	container.querySelectorAll('.catalog-collect--list-item').forEach((item) => {
		item.classList.remove('active');
	});
	saveSliderState(el);
});

typeof onTurboRender !== 'undefined' && onTurboRender(() => {
	window.requestAnimationFrame(restoreSliderState);
});
